import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthorizationGuard } from '@shared/authentication/authentication.guard';
import { CONTACTBOOK_PAGE } from '@shared/constants/routing-constants';

const routes: Routes = [
  {
    path: CONTACTBOOK_PAGE,
    canActivate: [AuthorizationGuard],
    loadComponent: () =>
      import('./pages/contacts/kfm-contact-page.component').then(
        (m) => m.KfmContactPageComponent,
      ),
  },
];

export const contactRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(routes);
